import React, { useEffect } from 'react';
import Button from './Button';

import '../stylesheets/B.scss';

import { useYouTube } from '../hooks';

function B(props) {
  const youTubeAPIPromise = useYouTube();

  useEffect(() => {
    youTubeAPIPromise.then((yt) => {
      let player = new yt.Player('yt-pie-in-the-sky', {
        height: '360',
        width: '640',
        videoId: '6zW5zaDiw04',
        playerVars: { rel: 0, enablejsapi: 1, autoplay: 1, mute: 1, listType: 'playlist', list: 'PL2LNe5vmCj3ayzzIAEMHmq0s7BS47cdTj', loop: 1 },
        title: 'Pie In The Sky',
      });
      console.log(player);
    });
  }, [youTubeAPIPromise]);

  return (
    <section className="b">
      <div className="video-section">
        <div className="pie-video" id="yt-pie-in-the-sky">
          <div id="pie-yt-video"></div>
        </div>
      </div>
      <div className="top-section">
        <h1>To Me, Wealth is balance.</h1>
        <h2>
          For the Elsen sisters, wealth became more than money when they opened their pie shop, Four and Twenty Blackbirds. Watch to see how they are reimagining wealth for
          themselves and their business.
        </h2>
      </div>
      <Button message={'Learn More'} link={`${props.stagingUrl}psychology-of-wealth/`} />
    </section>
  );
}

export default B;
